import { Component, OnInit } from '@angular/core';
import {SttTableComponent} from '../../../../../shared/components/stt-table/stt-table.component';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {StorageTypeModel} from '../../../../../shared/entities/storage-space.model';
import {StorageTypeAddEditComponent} from '../storage-type-add-edit/storage-type-add-edit.component';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ValidationMessageService } from '../../../../../shared/services/base/validation-message-handle';
import { StorageTypeService } from '../../../../../shared/services/app/storage-type.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-storage-type-table-action',
  templateUrl: './storage-type-table-action.component.html',
  styleUrls: ['./storage-type-table-action.component.scss']
})
export class StorageTypeTableActionComponent implements OnInit {

    public data: StorageTypeModel;
    public table: SttTableComponent;
    public ref: DynamicDialogRef;
    public loading = true;

    constructor(
        public dialogService: DialogService,
        public confirmationService: ConfirmationService,
        public primengConfig: PrimeNGConfig,
        public itemService: StorageTypeService,
        public messageService: MessageService,
        private validationMessageService: ValidationMessageService,
    ) {

    }

    ngOnInit(): void {
    }

    setParams(entity: StorageTypeModel): void {
        this.data = entity;
    }

    setTableReference(table: SttTableComponent): void
    {
        this.table = table;
    }


    showDialog() {
        this.ref = this.dialogService.open(StorageTypeAddEditComponent, {
            header: 'Modificare Tip Spatiu de Stocare',
            width: '30%',
            contentStyle: {'max-height': '70vh'},
            baseZIndex: 10000,
            closeOnEscape: false,
            data: this.data,
        });

        this.ref.onClose.subscribe((storage: StorageTypeModel) => {
            if (storage) {
                this.table.refresh();
            }
        });
    }

    confirm() {
        this.confirmationService.confirm({
            header: 'Confirmare stergere Tip Stocare',
            message: 'Sunteti sigur ca doriti sa stergeti acest Tip de stocare?',
            key: 'deleteStorageType',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Da',
            rejectLabel: 'Nu',
            acceptButtonStyleClass: 'p-button-md p-button-success',
            rejectButtonStyleClass: 'p-button-md p-button-danger',
            accept: () => {
                this.deleteItem(this.data.uid);
            },
            reject: () => {
                this.confirmationService.close();
                this.table.refresh();
            }
        });
    }

    deleteItem(uid: string){
        this.itemService.delete(uid)
            .pipe(finalize(() => {this.loading = false;this.table.refresh();}))
            .subscribe((response: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Tipul de stocare a fost sters cu success!'
                });
            });
    }

}
